export default "__VITE_ASSET__DXQ0aktc__"